module.exports = __webpack_public_path__ + "public/SiteIcons/plusIncrement.svg?90f05d9d";